import styles from './modal-components.module.css';

/**
 * Are there any use-cases that allow to close the modal with "back"?
 **/
export type ModalBackProps = {
  onBack: VoidFunction;
};

export const ModalBack = ({ onBack }: ModalBackProps) => (
  <button className={styles.backButton} onClick={onBack} aria-label="Back">
    <svg width="19" height="19" viewBox="0 0 19 19">
      <path d="M11.2813 14.25L6.53125 9.5L11.2813 4.75" fill="none" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  </button>
);
